export default __webpack_public_path__ + "3701b235b727c088bc1dcd56e5cbe9f4.png";